import styled from '@emotion/styled';

const SquareDotTable = styled.table`
    display: flex;
    border-spacing: 15px;
    position: absolute;
    right: 2rem;
    top: 2rem;
`;
const Dot = styled.td`
    width: 0.8rem;
    height: 0.8rem;
    background-color: white;
`;

const SquareDots = () => (
    <SquareDotTable>
        <tbody>
            {Array.from({ length: 5 }, (_, i) => (
                <tr key={i}>
                    {Array.from({ length: 5 }, (_, j) => (
                        <Dot key={`${i}_${j}`} />
                    ))}
                </tr>
            ))}
        </tbody>
    </SquareDotTable>
);

export default SquareDots;
